import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['desktopContainer', 'tabletContainer', 'mobileContainer']

    connect() {
        this.updateVisibility()
        this.boundUpdate = this.updateVisibility.bind(this)
        window.addEventListener('resize', this.boundUpdate)
    }

    disconnect() {
        window.removeEventListener('resize', this.boundUpdate)
    }

    updateVisibility() {
        const width = window.innerWidth

        const showDesktop = width > 1200
        const showTablet = width >= 768 && width <= 1200
        const showMobile = width < 768

        this.desktopContainerTargets.forEach(el => el.style.display = showDesktop ? 'block' : 'none')
        this.tabletContainerTargets.forEach(el => el.style.display = showTablet ? 'block' : 'none')
        this.mobileContainerTargets.forEach(el => el.style.display = showMobile ? 'block' : 'none')
    }
}
